import React, {Component} from "react"
import Select from "react-select"
import {FormattedMessage} from "react-intl"
import {observer} from "mobx-react"

import Paper from "@material-ui/core/Paper"
import TextField from "@material-ui/core/TextField"
import MenuItem from "@material-ui/core/MenuItem"

import classnames from "classnames"

import "./xsSearchSelect.less"
import {getFieldIdentifier} from "../../helpers/actions"
import {Tooltip} from "@material-ui/core"
import ReactTooltip from "react-tooltip"

function Menu(props) {
	return (
		<Paper
			square
			className={`xs-searchSelect-paper${props.selectProps.menuPlacement === "top" ? " menuOnTop" : ""}`}
			{...props.innerProps}
		>
			{props.children}
		</Paper>
	)
}

function NoOptionsMessage() {
	return (
		<div className="xs-searchSelect-noOption">
			<FormattedMessage id="Common.searchSelect.noOccurence" />
		</div>
	)
}

function SingleValue(props) {
	let code = ""
	let id = ""

	if (props.data) {
		id = props.data._id
		code = props.data.code
	}

	return (
		<div className="xs-searchSelect-singleValue" data-code={code} data-id={id}>
			{props.children}
		</div>
	)
}

function ValueContainer(props) {
	return (
		<div
			className={`xs-searchSelect-container ${props.selectProps.isClearable ? "clearable" : "no-clearable"}${
				props.selectProps.isMulti ? " isMulti" : ""
			}`}
		>
			{props.children}
		</div>
	)
}

function Placeholder(props) {
	return <div className="xs-searchSelect-placeholder">{props.children}</div>
}

// function DropdownIndicator(props) {
// 	return (
// 		<components.DropdownIndicator {...props}>
// 			<svg className="xs-searchSelect-dropdown" focusable="false" viewBox="0 0 24 24">
// 				<path d="M7 10l5 5 5-5z"></path>
// 			</svg>
// 		</components.DropdownIndicator>
// 	)
// }

function inputComponent({inputRef, ...props}) {
	return <div className="xs-searchSelect-inputComponent" ref={inputRef} {...props} />
}

function Control(props) {
	let inputClassName = "xs-searchSelect-input pointer"

	if (isSafe(props.selectProps.white)) {
		inputClassName += " bgSnowWhite"
	}

	return (
		<TextField
			error={!props.selectProps.isValid && !props.selectProps.isDisabled}
			data-tip
			data-for={isSafe(props.selectProps) && isSafe(props.selectProps.fieldId) ? props.selectProps.fieldId : null}
			data-multiline={true}
			disabled={props.selectProps.isDisabled}
			fullWidth
			variant="outlined"
			size="small"
			InputLabelProps={{shrink: true}}
			InputProps={{
				inputComponent,
				className: `xs-input-root${props.selectProps.isMulti ? " isMulti" : ""}`,
				// classes: {
				// 	root: props.selectProps.isValid ? "" : "xs-input-error"
				// },
				inputProps: {
					className: inputClassName,
					inputRef: props.innerRef,
					children: props.children,
					...props.innerProps
				}
			}}
			label={props.selectProps.hideLabel ? undefined : props.selectProps.labelJSX}
			{...props.selectProps.textFieldProps}
		/>
	)
}

function Option(props) {
	const option = getOption(props)
	if (props.selectProps && props.selectProps.tooltipProp && props.data && props.data[props.selectProps.tooltipProp]) {
		return <Tooltip title={props.data[props.selectProps.tooltipProp]}>{option}</Tooltip>
	}
	return option
}

function getOption(props) {
	return (
		<MenuItem
			buttonRef={props.innerRef}
			selected={props.isFocused}
			component="div"
			className={`xs-searchSelect-menuItem item-${props.value}`}
			style={{
				fontWeight: props.isSelected ? 500 : 300
			}}
			{...props.innerProps}
		>
			{props.children}
		</MenuItem>
	)
}

const mycomponents = {
	Control,
	Menu,
	NoOptionsMessage,
	Option,
	Placeholder,
	SingleValue,
	ValueContainer
}

/**
 * - Wrapped 'react-select' by Maros
 * - ak pouzijete komponentu do formulara s pouzitim mobx-react-form, staci poslat propu field a pripadne required
 * - pre obycajne pouzitie neposielajte field, object: items => {label: "", value: "", ...},
 * 		alebo pouzite getOptionLabel a getOptionValue pre nastavenie z vlastneho objektu
 * - pre renderovanie moznosti nad input nastavit menuPlacement="top"
 * - mozno sa zide aj konfigurovatelny min-width na paper (DDL), teraz je nastaveny cez CSS
 */

@observer
export default class SearchSelect extends Component {
	constructor(props) {
		super(props)

		this._isMounted = false

		this.state = {
			isValid: true
		}

		this.selectRef = null
	}

	componentDidMount() {
		this._isMounted = true
		if (isSafe(this.props.field) && this.props.disabled !== true) {
			this.handleValidation(this.props.field)
		}
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	componentDidUpdate() {
		if (isSafe(this.props.field) && (this.props.disabled !== true || this.props.force)) {
			this.handleValidation(this.props.field)
		}
	}

	handleValidation = (field) => {
		field.validate().then(({isValid}) => {
			if (this.state.isValid !== isValid) {
				if (this._isMounted) {
					this.setState({
						isValid: isValid
					})
				}
			}
		})
	}

	focus = () => {
		if (isSafe(this.selectRef)) {
			this.selectRef.focus()
		}
	}

	render() {
		const {
			field,
			items,
			label,
			value,
			onChange,
			className,
			required,
			disabled,
			hideLabel,
			placeholder,
			isMulti,
			isValid = true,
			menuPlacement,
			tooltipProp,
			white,
			onClear,
			disableTooltip = false
		} = this.props

		const isField = isSafe(field)
		const bindedField = isField ? field.bind() : undefined

		const labelJSX = isField ? (
			isSafe(bindedField.label) &&
			// isNotEmpty(bindedField.label.trim()) &&
			(required === true || (isSafe(field.get("rules")) && field.get("rules").includes("required"))) ? (
				<span className="xs-searchSelect-label xs-searchSelect-required">{bindedField.label} *</span>
			) : (
				<span className="xs-searchSelect-optional">{bindedField.label}</span>
			)
		) : required === true ? (
			<span className="xs-searchSelect-label xs-searchSelect-required">{label} *</span>
		) : (
			<span className="xs-searchSelect-optional">{label}</span>
		)

		const allItems = isSafe(items) ? items : []

		const handleOnChange = (formField) => (e, triggeredAction) => {
			if (isSafe(triggeredAction) && triggeredAction.action == "clear" && typeof onClear == "function") {
				onClear()
			}

			if (isNotSafe(e)) {
				formField.set("")
				formField.onChange("")
				this.handleValidation(formField)
				return
			}

			let val
			if (isSafe(e._id)) {
				val = e._id
			} else {
				val = e.code
			}

			if (formField.get("value") != val) {
				formField.set("value", val)
				formField.onChange(val)
			} else {
				formField.reset()
				formField.set("value", val)
			}
			if (typeof onChange == "function") {
				onChange(e)
			}
			this.handleValidation(formField)

			//Po tom ako sa vykonaju vsetky zmeny zavolam forceUpdate na rerender tooltipu
			setTimeout(() => {
				this.forceUpdate()
			}, 0)
		}

		const handleOnMultiChange = (formField) => (e, triggeredAction) => {
			if (isSafe(triggeredAction) && triggeredAction.action == "clear" && typeof onClear == "function") {
				onClear()
			}

			if (isNotSafe(e)) {
				formField.set([])
				formField.onChange([])
				this.handleValidation(formField)
				return
			}

			let vals = e.map((val) => {
				if (isSafe(val._id)) {
					return val._id
				} else {
					return val.code
				}
			})

			formField.set("value", vals)
			formField.onChange(vals)

			if (typeof onChange == "function") {
				onChange(vals)
			}

			this.handleValidation(formField)
		}

		const isMultiVal = isField ? field.options.isMulti === true : isMulti === true

		let defVal = null
		if (isField) {
			if (isMultiVal) {
				defVal = isNotEmpty(bindedField.value) ? allItems.filter((x) => bindedField.value.includes(x._id)) : []
			} else {
				defVal = isNotEmpty(bindedField.value) ? allItems.filter((x) => x._id === bindedField.value)[0] : ""
			}
		} else {
			defVal = value
		}

		const isDisabled = isField ? bindedField.disabled || disabled : disabled
		const additionalClasses = classnames(className, {disabled: isDisabled})

		let classIdentifier = getFieldIdentifier(field, additionalClasses)

		return (
			<React.Fragment>
				<Select
					ref={(input) => (this.selectRef = input)}
					className={`xs-searchSelect ${isSafe(classIdentifier) ? classIdentifier : ""}`}
					options={allItems}
					components={mycomponents}
					value={defVal}
					//Identifikator pre tooltip pouzity v Control
					fieldId={isSafe(field) ? "xsSearchSelect" + field.id : null}
					onChange={
						isField
							? field.options.isMulti === true
								? handleOnMultiChange(field)
								: handleOnChange(field)
							: (e) => onChange(e)
					}
					tabIndex={isSafe(this.props.tabindex) ? this.props.tabindex : null}
					getOptionLabel={
						isField
							? (opt) =>
									isSafe(this.props.getOptionLabel) && typeof this.props.getOptionLabel === "function"
										? this.props.getOptionLabel(opt)
										: opt.name_ext
							: isSafe(this.props.getOptionLabel) && typeof this.props.getOptionLabel === "function"
							? (opt) => this.props.getOptionLabel(opt)
							: undefined
					}
					getOptionValue={
						isField
							? (opt) => opt._id
							: isSafe(this.props.getOptionValue) && typeof this.props.getOptionValue === "function"
							? (opt) => this.props.getOptionValue(opt)
							: undefined
					}
					styles={{
						indicatorSeparator: () => {},
						dropdownIndicator: (provided, state) => {
							const padding = state.selectProps.isClearable ? "6px 4px 6px 2px" : "6px 4px 6px 4px"
							return {...provided, padding}
						},
						clearIndicator: (provided) => {
							const padding = "6px 2px 6px 4px"
							return {...provided, padding}
						}
					}}
					isClearable={
						isField
							? !(required === true || (isSafe(field.get("rules")) && field.get("rules").includes("required")))
							: required !== true
					}
					isMulti={isMultiVal}
					tooltipProp={tooltipProp}
					labelJSX={labelJSX}
					white={white}
					isDisabled={isDisabled}
					tabSelectsValue={true}
					isValid={this.state.isValid && isValid}
					hideLabel={hideLabel === true}
					placeholder={placeholder ? placeholder : null}
					//presunute na cely select
					// inputProps={
					// 	{
					// 		tabIndex: isSafe(this.props.tabindex) ? this.props.tabindex : ""
					// 	}
					// }
					menuPlacement={isSafe(menuPlacement) ? menuPlacement : "auto"} // auto | bottom | top // zatial funguje len top
				/>
				{isSafe(field) &&
					isSafe(this.selectRef) &&
					isSafe(this.selectRef.props) &&
					isSafe(this.selectRef.props.value) &&
					isSafe(this.selectRef.props.value.name_ext) &&
					disableTooltip == false && (
						<ReactTooltip className="custom-tooltip-line-height" data-multiline={true} id={"xsSearchSelect" + field.id}>
							{isNotEmpty(this.props.specialTooltip)
								? this.props.specialTooltip
								: isSafe(this.props.getOptionLabel) && typeof this.props.getOptionLabel === "function"
								? this.props.getOptionLabel(this.selectRef.props.value)
								: this.selectRef.props.value.name_ext}
						</ReactTooltip>
					)}
			</React.Fragment>
		)
	}
}

